<template>
  <div>
    <input v-model='value' class="w-full" />
    <!--
    <value-or-variable v-model='value' type='string' :variables='[]' @change='onChange'>
      <template #default=''>
      </template>
    </value-or-variable>
    -->
  </div>
</template>

<script>
import ValueOrVariable from '@ui/molecules/ValueOrVariable.vue';
import { abstractField } from "vue-form-generator";
export default {
  mixins: [ abstractField ],
  data() {
    let initialValue = this.value;
    if (!initialValue && this.schema.default) {
      initialValue = this.schema.default;
    }
    if (initialValue !== this.value) {
      this.$set(this, 'value', initialValue);
    }
    return {
    }
  },
  components:{
    //ValueOrVariable
  },
  methods: {
    onChange({nv,ov}) {
      this.$emit("change", {nv,ov});
    }
  },
  computed:{
  },
  watch: {
    value(nv, ov) {
      this.$emit("change", {nv,ov});
    }
  }
}
</script>

